<template>
	<div id="app">
		<!-- 加载中提示 -->
		<div class="po-fix" v-show="login_text" v-loading="login_text" :element-loading-text="login_text" element-loading-background="rgba(0,0,0,0.5)"></div>
		<keep-alive><router-view v-if="$route.meta && $route.meta.keepAlive"></router-view></keep-alive>
		<router-view v-if="!$route.meta || !$route.meta.keepAlive"></router-view>
	</div>
</template>
<script>
export default {
	name: 'Home',
	data() {
		return {};
	},
	methods: {},
	created() {},
	mounted() {
		let that = this;
		//designWidth:设计稿的实际宽度值，需要根据实际设置
		//maxWidth:制作稿的最大宽度值，需要根据实际设置
		//这段js的最后面有两个参数记得要设置，一个为设计稿实际宽度，一个为制作稿最大宽度，例如设计稿为750，最大宽度为750，则为(750,750)
		(function(designWidth, maxWidth, minWidth) {
			var doc = document,
				win = window,
				docEl = doc.documentElement,
				remStyle = document.createElement('style'),
				tid;

			function refreshRem() {
				var width = docEl.getBoundingClientRect().width;
				that.$store.commit('setWinSize', width);
				maxWidth = maxWidth || 540;
				width = width > maxWidth ? maxWidth : width < 1024 ? 1024 : width;
				var rem = (width * 100) / designWidth;
				remStyle.innerHTML = 'html{font-size:' + rem + 'px;min-width:' + minWidth + 'px}';
				that.$debug && console.log('rem', rem);
			}

			if (docEl.firstElementChild) {
				docEl.firstElementChild.appendChild(remStyle);
			} else {
				var wrap = doc.createElement('div');
				wrap.appendChild(remStyle);
				doc.write(wrap.innerHTML);
				wrap = null;
			}
			//要等 wiewport 设置好后才能执行 refreshRem，不然 refreshRem 会执行2次；
			refreshRem();

			win.addEventListener(
				'resize',
				function() {
					clearTimeout(tid); //防止执行两次
					tid = setTimeout(refreshRem, 10);
				},
				false
			);

			win.addEventListener(
				'pageshow',
				function(e) {
					if (e.persisted) {
						// 浏览器后退的时候重新计算
						clearTimeout(tid);
						tid = setTimeout(refreshRem, 10);
					}
				},
				false
			);

			if (doc.readyState === 'complete') {
				doc.body.style.fontSize = '16px';
			} else {
				doc.addEventListener(
					'DOMContentLoaded',
					function(e) {
						doc.body.style.fontSize = '16px';
						// doc.body.style.lineHeight = '24px';
					},
					false
				);
			}
		})(1920, 1920, 320);
	},
	computed: {
		// 加载中文本
		login_text() {
			return this.$store.state.login_text;
		}
	}
};
</script>
<style>
/* 全局样式重置文件最先引入 */
@import url('assets/css/global.css');
@import url('assets/css/color.css');
@import url('assets/css/flex.css');
@import url('assets/css/fs.css');
/* @import url('assets/css/pm_rem.css'); */
/* 去除滚动条 */
html {
	-ms-overflow-style: none;
	overflow: -moz-scrollbars-none;
	scrollbar-width: none;
}
*/
/* 谷歌适用 */
::-webkit-scrollbar {
	display: none;
}
.tran-time {
	transition: all 0.5s;
}
#app {
	font-family: Microsoft YaHei;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #333333;
}
.page {
	min-height: 100vh;
}
/* 内容宽度 */
.content {
	/* width: 14rem; */
	padding-right: 3.19rem !important;
	padding-left: 3.19rem !important;
	margin: 0 auto;
	transition: all 0.5s;
}

/* 投屏背景 */
.tp-bg {
	background-position: center top;
	background-repeat: no-repeat;
	background-size: 100%;
	background-image: url(https://imgtest.togy.com.cn/oyjj/langGuo/bg_video.png);
}
/* 前方圆点 */
.left-point {
	display: flex;
	flex-direction: row;
	align-items: center;
}
.left-point::before {
	content: '';
	display: block;
	width: 0.06rem;
	height: 0.06rem;
	border-radius: 0.03rem;
	background-color: #666;
	margin-right: 0.1rem;
}
.left-point-active::before {
	background-color: #d81216;
}
.left-point-active {
	color: #d81216;
}
/* 图片样式 */
.h-auto {
	width: 100%;
	height: auto;
}
.wh-100 {
	width: 100%;
	height: 100%;
}
/* 阴影 */
.box-sha {
	box-shadow: 4px 1px 24px 0px rgba(0, 0, 0, 0.13);
}

/* 快级元素 */
.dis-b {
	display: block;
}
/* 相对定位 */
.po-r {
	position: relative;
}
/* 标题 */
.big-title {
	text-align: center;
	font-size: 30px;
	font-weight: bold;
	padding-bottom: 0.5rem;
	position: relative;
	margin-bottom: 0.34rem;
}

.big-title::after {
	content: '';
	width: 0.26rem;
	height: 4px;
	display: block;
	background-color: #d81216;
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%);
}
/* 悬浮效果 */
.suspension:hover {
	background-color: #ffffff;
	box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.06);
	transform: scale(1.05);
	border-radius: 0.1rem;
}

/* 子元素浮动，并清除浮动导致的不占空间 */
.float * {
	float: left;
}
.float::after {
	content: '';
	clear: both;
	display: block;
}
/* 圆 */
.bor-10 {
	border-radius: 0.1rem;
}
.bor-50 {
	border-radius: 50%;
	overflow: hidden;
}
/* 鼠标小手 */
.cp {
	cursor: pointer;
}
.over-hi {
	overflow: hidden;
}

.h-auto {
	width: 100%;
	height: auto;
}

.hover-red:hover {
	color: #d81216;
}
.scale,
.scale-09 {
	transition: all 0.3s;
}
.scale:hover {
	transform: scale(1.1);
	opacity: 0.7;
}
.scale-09:hover {
	transform: scale(0.9);
	opacity: 0.7;
}

/* banner图上的文字 */
.banner-content {
	position: absolute;
	top: 40%;
	transform: translateY(-50%);
	font-size: 0.36rem;
	color: #ffffff;
	animation: down 0.5s;
	animation-fill-mode: forwards;
	animation-delay: 0.5s;
	opacity: 0;
}
@keyframes down {
	0% {
		top: 45%;
		opacity: 0;
	}
	80% {
		top: 60%;
		opacity: 0;
	}
	100% {
		top: 50%;
		opacity: 1;
	}
}

@media screen and (max-width: 1024px) {
	.h1 {
		font-size: 16px;
	}
	.h2 {
		font-size: 15px;
	}
	.h3 {
		font-size: 14px;
	}
	.h4 {
		font-size: 13px;
	}
	.h5 {
		font-size: 12px;
	}

	.ptb-123,
	.pt-123 {
		padding-top: 0.5rem;
	}

	.ptb-123,
	.pb-123 {
		padding-bottom: 0.5rem;
	}
}

@media screen and (max-width: 1024px) {
	.content,
	.phone-page {
		width: 100%;
		padding-right: 10px !important;
		padding-left: 10px !important;
	}
	.big-title {
		font-size: 24px;
	}
}
</style>



// WEBPACK FOOTER //
// src/App.vue